import type { ReactNode } from "react";
import type { User } from "oidc-client-ts";
import { logout } from "../auth/oidc";

type AppShellProps = {
  user: User;
  activeTenantId: string | null;
  onSignedOut: () => void;
  children: ReactNode;
};

function displayName(user: User) {
  return user.profile.email ?? user.profile.name ?? user.profile.sub;
}

export function AppShell({ user, activeTenantId, onSignedOut, children }: AppShellProps) {
  async function handleLogout() {
    onSignedOut();
    try {
      await logout();
    } catch {
      window.location.assign("/login");
    }
  }

  return (
    <div className="app-shell">
      <aside className="icon-rail" aria-label="Primary">
        <a className="rail-mark" href="/chat" aria-label="EvoBuddy home">
          EB
        </a>
        <nav>
          <a className="rail-item is-active" href="/chat" aria-label="Agent chat">
            C
          </a>
          <button className="rail-item" type="button" aria-label="Automations" disabled>
            A
          </button>
          <button className="rail-item" type="button" aria-label="Reports" disabled>
            R
          </button>
        </nav>
      </aside>
      <div className="shell-main">
        <header className="topbar">
          <div className="topbar-title">
            <p className="eyebrow">EvoBuddy</p>
            <h1>Business agent</h1>
          </div>
          <nav className="top-nav" aria-label="Workspace">
            <a className="is-active" href="/chat">
              Chat
            </a>
            <button type="button" disabled>
              Workflows
            </button>
            <button type="button" disabled>
              Activity
            </button>
          </nav>
          <div className="tenant-selector" aria-label="Tenant from token claims">
            <span>Tenant</span>
            <button type="button" disabled title="Tenant comes from signed token claims only">
              {activeTenantId ?? "Claim unavailable"}
            </button>
          </div>
          <div className="account-menu">
            <span>{displayName(user)}</span>
            <button type="button" onClick={() => void handleLogout()}>
              Sign out
            </button>
          </div>
        </header>
        <div className="content-region">{children}</div>
      </div>
    </div>
  );
}
